













import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ComponentVipBadge extends Vue {
  @Prop({ default: { id: '', tipoMedicoEOrdenacao: 'Padrao' }, required: true }) item: any

  get medicoVip() {
    if (this.item.tipoMedicoEOrdenacao === 'Vip') return 'Médico VIP'
    if (this.item.tipoMedicoEOrdenacao === 'VipAmbulatorio') return 'Vip Ambulatório'
    return ''
  }

  getLetter(item: any) {
    if (item.tipoMedicoEOrdenacao === 'VipAmbulatorio') return 'A'
    if (item.tipoMedicoEOrdenacao === 'Vip') return 'V'
    return ''
  }
}
